module.exports = ".add-edit-exam-call-dialog {\n  width: 600px; }\n\n.dialog-content-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/exam-calls/components/add-edit-exam-call/add-edit-exam-call.component.scss
// module id = ./src/app/main/content/pages/management/exam-calls/components/add-edit-exam-call/add-edit-exam-call.component.scss
// module chunks = main